import TextInputPhone from './text_input_phone';


export {
  TextInputPhone
};
